import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";
import task04 from "./layouts/task-04/task";

const lesson: Lesson = {
  id: "21c96ded-c958-4224-8fd0-e8282c32db53",
  publicId: "8",
  name: "Roughness & Fluctuation Strength",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, principle02, task01, task02, task03, task04],
};

export default lesson;
